import PropTypes from 'prop-types';

import { Layout, MinusPlusButtons } from '@utilities';

import { QUESTION_MAX_DIFF_MAX_SETS, QUESTION_MAX_DIFF_MIN_SETS } from '../../utilities/constants';

import styles from './_index.module.scss';

const NumberOfSets = ({ question, setNumberOfSets }) => {
  const numberOfSets = question.properties.numberOfSets;

  return (
    <Layout.Flex gap="small">
      Sets per respondent:
      <Layout.Flex className={styles['number-of-sets']} gap="x-small">
        <strong>{numberOfSets}</strong>
        <MinusPlusButtons
          disableMinusButton={numberOfSets <= QUESTION_MAX_DIFF_MIN_SETS}
          disablePlusButton={numberOfSets >= QUESTION_MAX_DIFF_MAX_SETS}
          isNeutral
          onClickMinus={() => {
            setNumberOfSets(Math.max(QUESTION_MAX_DIFF_MIN_SETS, numberOfSets - 1));
          }}
          onClickPlus={() => {
            setNumberOfSets(Math.min(QUESTION_MAX_DIFF_MAX_SETS, numberOfSets + 1));
          }}
        />
      </Layout.Flex>
    </Layout.Flex>
  );
};

NumberOfSets.propTypes = {
  question: PropTypes.object.isRequired,
  setNumberOfSets: PropTypes.func.isRequired,
};

export default NumberOfSets;
